import { axios } from '@/plugins/axios-pol'

export default class IntervencionC3ApiRepository {
  // Recupera el listado global de observaciones con intervención activa para un módulo (tipoModuloIntervencion)
  async getByTipoModulo(type) {
    const { data } = await axios.get(`/personal/api/EstadoFuerza/resultadosPersonalesC3/intervencion/tipo/${type}`)
    return data.data
  }
}
